import $ from 'jquery'
import DARSettingsSectionContainer from './darSettings/DARSettingsSectionContainer'
import {PasswordSettingsSectionContainerConnected} from './passwordSettings/PasswordSettingsSectionContainer'
import {initStore} from '../redux/store'
import createPasswordReducer from './passwordSettings/reducer'
import createMailReducer from './mailSettings/reducer'
import {combineReducers} from 'redux'
import RequirementSwitcher from './passwordSettings/components/RequirementSwitcher'

export function initSettingsAT(ValidatableFormBlocks) {
    new DARSettingsSectionContainer().init($('#accessToUserInfoSettingsBlock'))
    let {onModify, onSave} = ValidatableFormBlocks.register("passwordSettingsBlock");
    let container = new PasswordSettingsSectionContainerConnected({onModify, onSave}).init($('#passwordSettingsBlock'));
}


export function initSettingsAP(initialState, mailSettingsSpecified, loggedInUserPasswordMatchPolicy, ValidatableFormBlocks) {
    initStore({
        PASSWORD_SETTINGS: initialState,
        MAIL_SETTINGS: {
            mailSettingsSpecified,
        },
        IS_USER_PASSWORD_MATCHES_POLICY: loggedInUserPasswordMatchPolicy,
    }, initData => combineReducers({
        passwordSettings: createPasswordReducer(initData),
        mailSettings: createMailReducer(initData),
    }));
    let {onModify, onSave} = ValidatableFormBlocks.register("passwordSettingsBlock");
    let container = new PasswordSettingsSectionContainerConnected({
        onModify, onSave,
        checkboxComponent: RequirementSwitcher
    }).init($('#passwordSettingsBlock'));
}


// WEBPACK FOOTER //
// ./web/js/administration/index.js